import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsArtworkCardComponent } from './ds-artwork-card/ds-artwork-card.component';
import { DsArtworkGridComponent } from './ds-artwork-grid/ds-artwork-grid.component';

/**
 * Design-system shared module — declares + exports reusable presentation components
 * (the artwork card/grid) so any feature module can use them. Import this wherever you
 * render artworks. Keep it lean: only genuinely shared, dependency-light DS components.
 */
@NgModule({
    declarations: [
        DsArtworkCardComponent,
        DsArtworkGridComponent,
    ],
    imports: [CommonModule],
    exports: [
        DsArtworkCardComponent,
        DsArtworkGridComponent,
    ],
})
export class DsSharedModule { }
